var _style, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#27AAE1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.63,81.24c1.9-1,3.88-1.95,6.48-2.75c1.81-0.56,3.11-0.63,6.08-1.32c0,0,3.09-0.68,8.92-1.65 c12.14-2.02,21.86-0.55,27.79,0.34c10.3,1.56,10.69,3.49,25.43,7.6c15.16,4.23,23.93,6.68,35.06,6.05 c13.88-0.78,27.32-6.12,31.91-7.95c10.68-4.24,16.86-8.29,23.61-5.47c5.85,2.44,8.7,8.65,8.87,9.02c1.15,2.58,1.17,4.45,1.46,12.68 c0.53,14.71,0.08,3.84,0.49,12.68c0.54,11.75,0.51,20.97,0.49,29.76c-0.03,12-0.53,12.02-0.37,21.02c0.1,5.22,0.31,9.15,0.37,16.06 c0.05,5.67,0.01,12.12,0.01,12.12c-0.01,1-0.01,1.51-0.01,1.54c-0.65,6.93-11.4,11.21-17.07,13.66c-7.83,3.37-16.34,7.03-27.17,8.98 c-3.69,0.66-10.22,1.72-18.8,1.39c-8.06-0.31-13.97-1.79-25.45-4.74c-11.49-2.95-12.28-3.88-25.16-7.1c-11.98-3-16.5-3.49-20.01-3.7 c-3.09-0.18-9.28-0.51-17.06,0.77c-0.8,0.13-0.48,0.09-12.14,2.7c-11.63,2.6-11.4,2.52-12.4,2.8c-7.96,2.29-9.2,3.77-11.07,2.79 c-2.87-1.51-2.89-6.89-2.93-15.61c-0.02-4.33,0.31-5.27,0.49-11.71c0.15-5.24,0.05-8.82,0-11.71c-0.06-3.5-0.04-5.42,0.49-30.73 c0.49-23.79,0.51-23.61,0.49-23.9c-1.08-15.27-4.42-21.9,0-26.83C78.03,86.28,81.23,84.6,87.63,81.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.61,258.32h-8.78c-5.66,0-10.24-4.59-10.24-10.24V90.51c0-5.66,4.59-10.24,10.24-10.24h8.78 c5.66,0,10.24,4.59,10.24,10.24v157.56C78.85,253.73,74.27,258.32,68.61,258.32z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 63.45,
    cy: 71.73,
    rx: 25.62,
    ry: 22.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBlue);
export default __webpack_public_path__ + "static/media/flag-blue.2e82c0ace7c810899c8af76f64747842.svg";
export { ForwardRef as ReactComponent };